export default "__VITE_ASSET__CNzn8xxR__"